<template>
	<div class="text-left" @click="$emit('click',$event)" v-if="isConditionMet">
		<div class="form-question">{{ item.question }} <span v-if="item.required" class="font-red brand-medium">*</span>  <v-icon v-if="showConditionalHelper" small color="gray_50">account_tree</v-icon></div>
		<v-form @submit.prevent v-model="isValid" lazy-validation ref="form">
			<v-textarea
					hide-details
					dense
					v-model="textInput"
					:placeholder="item.placeholder"
					:outlined="outlined"
					:solo="solo"
					:filled="filled"
					:disabled="disabled"
					:rows="item.rows"
					class="form-input"
					:rules="item.required ? inputRequired : []"
					@input="handleInput()"
			></v-textarea>
		</v-form>
	</div>
</template>

<script>
import RendererMixin from "@/modules/forms/v2/schema/RendererMixin";

export default {
	name: "TextArea",

	props: ['disabled', 'item', 'styles', 'index','results','builder','container'],

	mixins: [RendererMixin],

	components: {},

	data: function () {
		return {
			textInput: null
		}
	},

	mounted() {
		let currentResult = this.getCurrentResult(this.item.id,this.results);
		if(currentResult){
			this.textInput = currentResult;
		}
	},

	beforeDestroy() {
	},

	methods: {
		handleInput: function(){
			this.$emit('input',{item:this.item,value: this.textInput, index: this.index, container: this.container});
		}
	},

	computed: {},

}
</script>

<style scoped lang="scss">

</style>